/* Spanish catalog mirroring locale-invoice-payment-actions-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'inv.pay.undoPayment': 'Deshacer pago',
  'inv.pay.undoRefund': 'Deshacer reembolso',
  'inv.pay.undoPaymentTitle': '¿Deshacer el pago registrado?',
  'inv.pay.undoRefundTitle': '¿Deshacer el reembolso registrado?',
  'inv.pay.undoPaymentBody': 'El pago se revertirá y la factura se reabrirá con el importe pendiente correspondiente. El asiento original se conserva en el historial de auditoría.',
  'inv.pay.undoRefundBody': 'El reembolso se revertirá y el crédito del cliente se reabrirá. El asiento original se conserva en el historial de auditoría.',
  'inv.toast.paymentReversed': 'Pago revertido',
  'inv.toast.refundReversed': 'Reembolso revertido',
  'inv.err.paymentReverseFailed': 'No se pudo revertir el pago.',
  'inv.err.refundReverseFailed': 'No se pudo revertir el reembolso.',
});
